import { render, staticRenderFns } from "./layout-admin.vue?vue&type=template&id=9805a276&"
import script from "./layout-admin.vue?vue&type=script&lang=js&"
export * from "./layout-admin.vue?vue&type=script&lang=js&"
import style0 from "./layout-admin.vue?vue&type=style&index=0&id=9805a276&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports